import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isScaleFieldDef, vgField } from '../../channeldef';
import { fieldFilterExpression } from '../../predicate';
import { isSortArray } from '../../sort';
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
import { getDependentFields } from './expressions';
/**
 * We don't know what a calculate node depends on so we should never move it beyond anything that produces fields.
 */

export var CalculateNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(CalculateNode, _DataFlowNode);

  function CalculateNode(parent, transform) {
    var _this;

    _classCallCheck(this, CalculateNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CalculateNode).call(this, parent));
    _this.transform = transform;
    _this._dependentFields = getDependentFields(_this.transform.calculate);
    return _this;
  }

  _createClass(CalculateNode, [{
    key: "clone",
    value: function clone() {
      return new CalculateNode(null, duplicate(this.transform));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set([this.transform.as]);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return this._dependentFields;
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return {
        type: 'formula',
        expr: this.transform.calculate,
        as: this.transform.as
      };
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Calculate ".concat(_hash(this.transform));
    }
  }], [{
    key: "parseAllForSortIndex",
    value: function parseAllForSortIndex(parent, model) {
      // get all the encoding with sort fields from model
      model.forEachFieldDef(function (fieldDef, channel) {
        if (!isScaleFieldDef(fieldDef)) {
          return;
        }

        if (isSortArray(fieldDef.sort)) {
          var field = fieldDef.field,
              timeUnit = fieldDef.timeUnit;
          var sort = fieldDef.sort; // generate `datum["a"] === val0 ? 0 : datum["a"] === val1 ? 1 : ... : n` via FieldEqualPredicate

          var calculate = sort.map(function (sortValue, i) {
            return "".concat(fieldFilterExpression({
              field: field,
              timeUnit: timeUnit,
              equal: sortValue
            }), " ? ").concat(i, " : ");
          }).join('') + sort.length;
          parent = new CalculateNode(parent, {
            calculate: calculate,
            as: sortArrayIndexField(fieldDef, channel, {
              forAs: true
            })
          });
        }
      });
      return parent;
    }
  }]);

  return CalculateNode;
}(DataFlowNode);
export function sortArrayIndexField(fieldDef, channel, opt) {
  return vgField(fieldDef, Object.assign({
    prefix: channel,
    suffix: 'sort_index'
  }, opt || {}));
}